import { startTransition, useCallback, useEffect, useMemo, useState } from 'react';
export const useTokenizerFocusState = ({
  maxIndex,
  focusedIndexState
}) => {
  const defaultFocusedIndexState = useState();
  const [focusedIndex, setFocusedIndex] = focusedIndexState ?? defaultFocusedIndexState;
  const onContainerBlur = e => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      startTransition(() => {
        setFocusedIndex(undefined);
      });
    }
  };
  const [focusColumnIndex, setFocusColumnIndex] = useState(0);
  const onUpdateFocus = useCallback((tokenIndex, columnIndex) => {
    if (columnIndex !== undefined && (
    // Only update columnIndex when the token index is valid
    tokenIndex >= 0 && tokenIndex <= maxIndex ||
    // MAX_SAFE_INTEGER is the flag used to indicate moving focus to the last token
    tokenIndex === Number.MAX_SAFE_INTEGER)) {
      setFocusColumnIndex(columnIndex);
    }
    setFocusedIndex(Math.max(0, Math.min(maxIndex, tokenIndex)));
  }, [maxIndex, setFocusedIndex]);

  // Update focusedIndex so that it is always less than maxIndex
  useEffect(() => {
    if (maxIndex < 0) {
      setFocusedIndex(undefined);
      setFocusColumnIndex(0);
    } else if (focusedIndex !== undefined) {
      setFocusedIndex(Math.min(maxIndex, focusedIndex));
    }
  }, [maxIndex, focusedIndex, setFocusedIndex]);
  const tokensContextValue = useMemo(() => ({
    focusTokenIndex: focusedIndex,
    focusColumnIndex,
    onUpdateFocus
  }), [focusColumnIndex, focusedIndex, onUpdateFocus]);
  const onInputFocus = () => {
    setFocusedIndex(undefined);
  };
  return {
    focusedIndex,
    tokensContextValue,
    onContainerBlur,
    onInputFocus
  };
};
//# sourceMappingURL=useTokenizerFocusState.js.map